import { render, staticRenderFns } from "./TopicList.vue?vue&type=template&id=58b4053e&scoped=true"
import script from "./TopicList.vue?vue&type=script&lang=js"
export * from "./TopicList.vue?vue&type=script&lang=js"
import style0 from "./TopicList.vue?vue&type=style&index=0&id=58b4053e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b4053e",
  null
  
)

export default component.exports